import CommonUtil from '../util/CommonUtil';
import './Login.css'
import {useState, useRef} from 'react'
import { useAuth } from '../context/AuthContext';

declare global {
    interface Window {
      Kakao: any;
      naver: any;
    }
}

const loadScript = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script ${src}`));
        document.head.appendChild(script);
    });
};

function Login(){
    const { initiateLogin } = useAuth();
    const [id, setId] = useState('')
    const [password, setPassword] = useState('')
    const naverLoginButton = useRef<HTMLDivElement>(null);

    const handleNaverLogin = () => {
        CommonUtil.logEvent("login", { method: "naver" });
        loadScript('https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js')
            .then(() => {
                if (window.naver && naverLoginButton.current) {
                    const naverLogin = new window.naver.LoginWithNaverId({
                        clientId: 'mooJ6uKc9YUIXe8lTZ4B',
                        callbackUrl: `${window.location.origin}/login/naver/callback`,
                        isPopup: false,
                        loginButton: { color: 'green', type: 3, height: 60 },
                    });
                    naverLogin.init();

                    const clickButton = () => {
                        if (naverLoginButton.current?.firstChild) {
                            (naverLoginButton.current.firstChild as HTMLElement).click();
                        } else {
                            setTimeout(clickButton, 50);
                        }
                    };
                    clickButton();
                }
            })
            .catch(console.error);
    };

    const handleKakaoLogin = () => {
        CommonUtil.logEvent("login", { method: "kakao" });
        loadScript('https://t1.kakaocdn.net/kakao_js_sdk/2.7.6/kakao.min.js')
            .then(() => {
                if (window.Kakao) {
                    if (!window.Kakao.isInitialized()) {
                        window.Kakao.init('18e9de2241aed6649389f40ae332cc93');
                    }
                    window.Kakao.Auth.authorize({
                        redirectUri: `${window.location.origin}/login/kakao/callback`,
                    });
                }
            })
            .catch(console.error);
    };

    const handleAppleLogin = () => {
        CommonUtil.logEvent("login", { method: "apple" });
        initiateLogin('apple');
    };

    const BACKEND_URL = (process.env.REACT_APP_BACKEND_API_URL ?? 'http://localhost:3000').trim();
    return(
        <>
            <div className="container">
                <div className="login-container">
                    <h2>플레이볼 로그인</h2>
                    <img src="/naver.png" 
                        className="login-button" 
                        alt="네이버 로그인"
                        onClick={handleNaverLogin}/>
                    <div ref={naverLoginButton} style={{ display: 'none' }} id="naverIdLogin"></div>
                    
                    <img src="/kakao.png" 
                        className="login-button"
                        alt="카카오 로그인"
                        onClick = {handleKakaoLogin}/>

                    <img src="/apple.png" 
                        className="login-button"
                        alt="애플 로그인"
                        onClick = {handleAppleLogin}/>

                    {/* <img src="/google.png" 
                        className="login-button"
                        alt="구글 로그인"
                        onClick = {() => initiateLogin('google')}/> */}

                    {
                        !window.location.host.startsWith('www') &&
                        <>
                            <hr></hr>

                            <form action={`${BACKEND_URL}/api/oauth/password`} onSubmit={() => CommonUtil.logEvent("login", { method: "password" })}>
                                <input type="text" 
                                    id="id" 
                                    name="id" 
                                    className="form-control" 
                                    placeholder="아이디"
                                    value={id}
                                    onChange={(e) => setId(e.target.value)}/>

                                <input type="text" 
                                    id="password" 
                                    name="password" 
                                    className="form-control" 
                                    placeholder="비밀번호"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}/>

                                <input type="hidden"
                                    id="frontend_redirect_uri"
                                    name="frontend_redirect_uri"
                                    value={window.location.origin + '/auth/callback'} />
                                    
                                <button id="submit" className="btn btn-primary mt-2">
                                    로그인
                                </button> 
                            </form>
                        </>
                    }
                 
                    {/* <a href="/api/oauth/google" class="login-button google-button">Login with Google</a> */}
                </div>
            </div>
        </>
    );
}
export default Login;